// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminOptionMenu_container__3THTD"};